import React, { useState } from "react";
import "./Results.css";
import axios from "axios";
import Loader from "react-loader-spinner";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

const apiKey = "07319c98d31cd264100357f318c29dd2";

export default function Results(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  function handleResponse(response) {
    //console.log(response.data);
    setWeatherData({
      ready: true,
      city: response.data.name,
      coord: response.data.coord,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      humidity: response.data.main.humidity,
      temperature: response.data.main.temp,
      wind: response.data.wind.speed,
      icon: response.data.weather[0].icon,
    });
  }

  function search() {
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search(city);
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  function showCurrentLocation(position) {
    let lat = position.coords.latitude;
    let lon = position.coords.longitude;
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleCurrentLocation(event) {
    event.preventDefault();
    navigator.geolocation.getCurrentPosition(showCurrentLocation);
  }

  if (weatherData.ready) {
    return (
      <div className="Results">
        <form id="search-engine" onSubmit={handleSubmit}>
          <div className="search-container">
            <div className="row">
              <div className="col-8">
                <input
                  type="search"
                  placeholder="Where to?"
                  autoComplete="off"
                  autoFocus="on"
                  id="search-box"
                  onChange={handleCityChange}
                />
              </div>
              <div className="col-2">
                <input type="submit" value="SEARCH" id="search-button" />
              </div>
              <div className="col-2">
                <input
                  type="submit"
                  value="HOME"
                  className="home-button"
                  id="currentLocationBttn"
                  onClick={handleCurrentLocation}
                />
              </div>
            </div>
          </div>
        </form>
        <WeatherInfo data={weatherData} />
        <WeatherForecast coord={weatherData.coord} />
      </div>
    );
  } else {
    search();
    return (
      <div className="loadingScreen">
        <h4>Loading...</h4>
        <Loader type="TailSpin" color="#e75480" height={80} width={80} />
      </div>
    );
  }
}
